import React, {useState} from 'react';
import Slider from 'react-slick';
import styled from 'styled-components'
import Container from "./Container";
import SocialMenu from "./SocialMenu";
import merkel from "../images/merkel.jpg";

// import Image from 'gatsby-image';


const Turnir = () => {
  const settinggs = {
    dots: false,
    arrows: false,
    infinite: false,
    speed: 1000,
    autoplaySpeed: 10000,
    fadeIn: false,
    autoplay: false,
    pauseOnHover: false,
    slidesToShow: 2,
    centerMode: false,
    // variableWidth: true,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
        },
      },
    ],
  };


  const StyledImage = styled.img`
    border-radius: 1rem;
    max-width: 80rem;
    margin: 0 auto;
    margin-bottom: 2rem;
  `
  const StyledContainer = styled(Container)`
  .homepage-pop-up{
      bottom: 90px;
      left: 40px;
      margin: 0;
      padding: 30px;
      position:absolute;
      border-radius: 1px;
      ybox-shadow: 0 0 30px 0 rgba(0, 0, 0, 0.2);
      .SocialMenu__Wrapper-jWHUUx{
      margin: 0;
      ul{
      display:none;
      }
    }
    h5{
    margin-top: 30px;
    margin-bottom: 20px;
    font-size: 28px;
    font-weight: bold;
    font-style: italic;
    line-height: 1;
    letter-spacing: normal;
    color: #e3051b;
    }
    p{
    font-size: 16px;
    font-weight: normal;
    font-style: italic;
    line-height: 1.25;
    letter-spacing: normal;
    color: #2c2c2c;
    }
    .span2{
    border-top: 35px solid #ffffff;
    background-color: transparent !important;
    border-right: 35px solid transparent;
    position: absolute;
    bottom: -34px;
    left: 25px;
    margin:0;
    padding:0;
    width: auto;
    }
  }
`

  const [turnirOpen, setTurnirOpen] = useState(false);

  return (
    <div className={'gifs'}>
      <StyledContainer>
        <div className={'wrapper-content'}>
          <span className={'gray-span'} id={'turnier'}>TOURNAMENT INFORMATION</span>

          <div className={'merkel-greetings'}>
            <img src={merkel} alt="merkel" />
            <div className={'text'}>
              <p>"The corona pandemic also means a difficult exceptional situation in top tennis. As patron, I regret that this year's Grass Court Championships Berlin cannot take place. I am all the more pleased about the <span class = "bold"> bett1ACES </span> as an attractive substitute tournament.</p> 
              <p>I wish the players a happy hand and all tennis fans who follow the competitions on the screen, exciting entertainment from the first serve to the last match ball."</p>
              <p class="bold"><span class="bold">Angela Merkel, Chancellor</span></p>
            </div>
          </div>

          <Slider {...settinggs} className={'npm-slick'}>
            <div>
              <div className={'one-gif-content'}>
                <h2>LADIES </h2>
                <div className={'content-gifs'}>
                  <div className={'women-men-gif'}>
                    <span className={'red-span'}>DAY 1 – QUARTER FINALE</span>
                  </div>
                  <div className={'women-men-gif'}>
                    <span className={'red-span'}>DAY 2 – HALF FINALE</span>
                  </div>
                  <div className={'women-men-gif'}>
                    <span className={'red-span'}>DAY 3 – FINALE</span>
                  </div>
                </div>
                <div className={'white-bg english women'}>
                </div>
              </div>
            </div>
            <div>
              <div className={'one-gif-content'}>
                <h2>GENTLEMEN</h2>
                <div className={'content-gifs'}>
                  <div className={'women-men-gif'}>
                    <span className={'red-span'}>DAY 1 – QUARTER FINALE</span>
                  </div>
                  <div className={'women-men-gif'}>
                    <span className={'red-span'}>DAY 2 – HALF FINALE</span>
                  </div>
                  <div className={'women-men-gif'}>
                    <span className={'red-span'}>DAY 3 – FINALE</span>
                  </div>
                </div>
                <div className={'white-bg english men'}>
                </div>
              </div>
            </div>
          </Slider>
          <div className={'button-with-hover'}>
            <a className={'gif-button'} onClick={ (e) => { e.preventDefault(); setTurnirOpen( !turnirOpen )  } }>
              { !turnirOpen ? 'Show more' : 'Close profile' }
            </a>
            {turnirOpen ?
            <div className={'homepage-pop-up'}>
              <SocialMenu/>
              <h5>
                TOURNAMENT INFORMATION
              </h5>
              <p>„World class tennis, top players, grass and hard courts at two breathtaking locations in Berlin“</p>
              <p>The tennis world looks to Berlin. World class players meet at the historical Steffi-Graf-Stadium and a unique state of the art location. The event will take place without spectators.</p>

                <p><strong>Locations | Period | Surfaces: </strong></p>
              <p>BERLIN | Steffi-Graf-Stadium | 13th –15th July 2020 | Grass Court<br></br>
                BERLIN | Tempelhof Hangar | 17th –19th July 2020 | Hard Court</p>
              <div className={'inner-div'}>
                <p><strong>Players:<br></br>Game format:</strong></p>
                <p>6 women and 6 men<br></br>2 seeded players
                  Best of three sets<br></br>
                  Third set match-tie-break
                </p>
              </div>
              <div className={'inner-div'}>
                <p><strong>Electronic Features:</strong></p>
                <p>Innovatives TV-Übertragungskonzept durch <br></br>
                  TV Drohnen, 360° LED & Electronic Line Calling</p>
              </div>
              <span className={'span2'}></span>
            </div>
             : ''}
          </div>
        </div>
      </StyledContainer>
    </div>
  )
};

export default Turnir;
